import { FilterExpression, like, Sort } from '@infuse/api/common';

export interface Options {
  query?: string;
  filter?: FilterExpression;
  sort?: Sort[];
}

const createSearchFilter = (searchQuery: string, matchObject = false): FilterExpression | undefined => {
  if (searchQuery === '' && !matchObject) {
    return;
  }

  const filterOptions = searchQuery
    .toLowerCase()
    .replace('%', '\\%')
    .split(' ')
    .filter((part: string): boolean => part !== undefined && part !== null && part !== '')
    .map((part: string): string => `%${part}%`)
    .map(
      (part: string): FilterExpression =>
        like('lower(id)', part)
          .or(like('lower(name)', part))
          .or(like('lower(description)', part))
          .or(like('lower(version)', part))
          .or(like('lower(filename)', part))
    );

  if (filterOptions.length === 0) {
    return;
  }

  return filterOptions.reduce((acc, cv) => acc.and(cv), new FilterExpression());
};

export const aggregateSearchQueryAndFilters = (options: Options, matchObject = false): FilterExpression | undefined => {
  // combines regular filters with the search filter
  const searchFilter = createSearchFilter(options.query || '', matchObject);
  const filterCopy = new FilterExpression(); // copy is needed since FilterExpression methods alter the object itself
  filterCopy.operations = Object.assign([], options.filter?.operations); // shallow copy

  if (searchFilter) {
    return options.filter ? filterCopy.and(searchFilter) : searchFilter;
  } else {
    return options.filter;
  }
};
